export default "__VITE_ASSET__CU253Uqp__"